import * as faker from 'faker';
import { optional, randomArray } from '@library/common/functions';

import {
   Report,
   ReportFilter,
   ReportColumn,
   ReportSchema,
} from './report';

export { MockReportResponse } from './report/report-response.mock';

// exporting as MockReportList for backwards compatiability
// TODO: should be refactored to use the ...Item
export { MockReportListItem as MockReportList } from './list/report-list-item.mock';

export class MockReport extends Report {
   constructor() {
      super({
         id: +faker.datatype.number( 100 ),
         name: faker.company.catchPhrase(),
         owned: true,
         shared: faker.datatype.boolean(),
         version: faker.datatype.number(),
         filters: randomArray( MockReportFilter, 5, 1 ),
         schema: randomArray( MockReportSchema, 20, 1 ),
         last_updated: faker.date.past(),
      });
   }
}

export class MockReportFilter extends ReportFilter {
   constructor() {
      super({
         name: faker.lorem.word(),
         value: faker.lorem.word(),
      });
   }
}

export class MockReportSchema extends ReportSchema {
   constructor() {
      super({
         name: faker.lorem.word(),
         header: optional() ? faker.company.catchPhrase() : null,
         sort_ord: optional(),
         sort_dir: optional() ? 'asc' : 'desc'
      });
   }
}

export class MockReportColumn extends ReportColumn {
   constructor() {
      super({
         name: faker.lorem.word(),
         header: faker.lorem.word(),
         type: faker.random.arrayElement([ 'string', 'number', 'date', 'boolean' ]),
         width: optional() ? faker.datatype.number( 300 ) : undefined,
         columns: faker.datatype.boolean(),
         filters: optional( 10 ),
      });
   }
}
